// reducer.js
import * as actionTypes from "actions";

const initialState = {
  Loading: false,
  paretoChartSummary: [],
};

const paretoChartReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PARETO_CHART_REQUEST:
      return {
        ...state,
        Loading: true,
      };
    case actionTypes.PARETO_CHART_SUMMARY_SUCCESS:
      return {
        ...state,
        Loading: false,
        paretoChartSummary: action.paretoChartSummary,
      };
    default:
      return state;
  }
};

export default paretoChartReducer;
